var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Many Line Graph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,60V2H5V4H2V6H5V18H2v2H5V32H2v2H5V46H2v2H5V61a1,1,0,0,0,1,1H62V60Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.171,48.9,18.2,51.6a1,1,0,0,0,1.729-.228l3.1-7.759,2.049,4.781a1,1,0,0,0,1.7.231l3.024-3.78,2.3,4.6a1.022,1.022,0,0,0,.943.552,1,1,0,0,0,.886-.64l9-23.4,2.119,6.356a1,1,0,0,0,1.729.309l2.973-3.717,3.332,7.5a1,1,0,0,0,1.894-.21l3-15L56.02,20.8,53.637,32.719l-2.723-6.125a1,1,0,0,0-1.7-.219L46.367,29.94l-2.419-7.256A1,1,0,0,0,43.022,22a.976.976,0,0,0-.956.641L32.881,46.525,30.9,42.553a1,1,0,0,0-1.676-.178l-2.957,3.7-2.343-5.466A1.076,1.076,0,0,0,22.988,40a1,1,0,0,0-.917.628l-3.339,8.349L16.8,46.4a1,1,0,0,0-1.7.153l-4,8,1.79.894Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 13,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 17,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 13,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 13,
    y: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.469fda20b2b164bdd0222f558b446a04.svg";
export { ForwardRef as ReactComponent };